/**
 * @packageDocumentation
 * Displays the contextual bottom-strip win panel, tinting and messaging each scenario before the final win popup appears.
 */
import * as PIXI from "pixi.js";
import { Assets } from "pixi.js";
import { font_third } from "./global";
import { ScenarioResult, currencySymbol, ShowCent } from "./server";
import { spriteAnimCreator } from "../lib/spriteAnimCreator";

const CHARACTER_TINTS: Record<number, PIXI.ColorSource> = {
  0: "#004183", // Blue
  1: "#27902e", // Green
  2: "#330d3f", // Purple
  3: "#872002", // Red
  4: "#ffaf11", // Yellow
};

const BORDER_TINTS: Record<1 | 2 | 3 | 4, PIXI.ColorSource> = {
  1: "#782c2cfb", // Bronze / Black
  2: "#e8e8e8", // Silver
  3: "#dea632", // Gold
  4: "#026bb1ff", // Holographic
};


const BgIndex ={
  
}


const SUPER_TINT: PIXI.ColorSource = "#0890dfff";
const DEFAULT_TINT: PIXI.ColorSource = "#1f0000";
const CENT_SIGN = "\u00A2";

const formatAmount = (raw: number): string => {
  const value = Number.isFinite(raw) ? raw : 0;
  let formatted = `${currencySymbol}${value.toFixed(2)}`;
  if (ShowCent && value < 1 && value > 0) {
    formatted = `${(value * 100).toFixed(2)}${CENT_SIGN}`;
  }
  return formatted;
};

const tintForScenario = (result: ScenarioResult): PIXI.ColorSource => {
  if (result.scenario === "sameCharacter" && typeof result.color === "number") {
    return CHARACTER_TINTS[result.color] ?? DEFAULT_TINT;
  }
  if (result.scenario === "sameBorder" && result.border) {
    return BORDER_TINTS[result.border] ?? DEFAULT_TINT;
  }
  if (result.scenario === "allSuper") {
    return SUPER_TINT;
  }
  return DEFAULT_TINT;
};
const bgForScenario = (result: ScenarioResult): number => {
  console.log("testing bgForScenario", result)
  if (result.scenario === "sameCharacter" && typeof result.color === "number") {
    return result.color;
  }
  if (result.scenario === "sameBorder" && result.border) {
    return result.color ?result.color + result.border: 0;
  }
  if (result.scenario === "allSuper") {
    return 9;
  }
  return 0;
};

export default class bottomWin extends PIXI.Container {
  public numberBg!: PIXI.Sprite;
  public numberBgAnimatedSprite!: PIXI.AnimatedSprite;
  public WinDescription!: PIXI.Text;
  public WinValue!: PIXI.Text;

  constructor() {
    super();
    this.createBottomWin();
  }

  private createBottomWin() {
    let WinBgArr: PIXI.Texture<PIXI.TextureSource<any>>[] = spriteAnimCreator(2, 5, 10, Assets.get("winvalue_bg"));
    this.numberBgAnimatedSprite = new PIXI.AnimatedSprite(WinBgArr);
    this.numberBgAnimatedSprite.anchor.set(0.5);
    this.numberBgAnimatedSprite.scale.y = 1.2;
    this.addChild(this.numberBgAnimatedSprite);

    this.numberBg = new PIXI.Sprite(Assets.get("winvalue_bg"));
    this.numberBg.anchor.set(0.5);
    this.numberBg.scale.y = 1.2;
    this.numberBg.tint = DEFAULT_TINT;
    // this.addChild(this.numberBg);

    this.WinDescription = new PIXI.Text({
      text: "",
      style: {
        fontFamily: font_third,
        dropShadow: {
          alpha: 0.8,
          angle: 1,
          blur: 4,
          color: "0x111111",
          distance: 2,
        },
        align: "center",
        fill: "#ffffff",
        fontSize: 30,
        fontWeight: "bold",
        letterSpacing: 1,
        stroke: {
        color: "black",
        width: 1,
        join: "round",
      },
      },
    });
    this.WinDescription.anchor.set(0.5);
    this.WinDescription.y = -this.numberBgAnimatedSprite.height / 4+2;
    this.addChild(this.WinDescription);

    this.WinValue = new PIXI.Text({
      text: formatAmount(0),
      style: {
        fontFamily: font_third,
        dropShadow: {
          alpha: 0.8,
          angle: 1,
          blur: 4,
          color: "0x111111",
          distance: 2,
        },
        align: "center",
        fill: "#ffe600",
        fontSize: 40,
        fontWeight: "bold",
        stroke: {
        color: "black",
        width: 1,
        join: "round",
      },
      },
    });
    this.WinValue.anchor.set(0.5);
    this.WinValue.y = this.numberBgAnimatedSprite.height / 4 - 15;
    this.addChild(this.WinValue);
  }

  updateBottomBg(color: PIXI.ColorSource) {
    this.numberBg.tint = color;
  }
  updateBottomBgSprite(index: number) {
    this.numberBgAnimatedSprite.gotoAndStop(index);
  }

  updateBottomDescription(text: string) {
    this.WinDescription.text = text;
  }

  updateBottomWintext(text: string) {
    this.WinValue.text = text;
  }

  updateBottomWin(data: [PIXI.ColorSource, string, string,number]) {
    this.updateBottomBg(data[0]);
    this.updateBottomDescription(data[1]);
    this.updateBottomWintext(data[2]);
    this.updateBottomBgSprite(data[3]);
  }

  updateForScenario(result: ScenarioResult) {
    const tint = tintForScenario(result);
    const bgIndex = bgForScenario(result);
    this.updateBottomWin([tint, result.displayText, formatAmount(result.amount),bgIndex]);
    // this.WinValue.style.fill = tint as any;
  }
}
